import { Component, OnInit, NgZone } from '@angular/core';
import { API_BASE_URL } from 'src/environments/environment';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-area-master',
  templateUrl: './area-master.component.html',
  styleUrls: ['./area-master.component.less']
})
export class AreaMasterComponent implements OnInit {

  tab = 1;

  areaList = [];
  areaRelatedList = [];

  selectedArea;
  selectedAreaRelated;

  updateArea;
  updateAreaRelated;

  areaEditMode = false;
  areaRelatedEditMode = false;

  users = [];

  beforeArea: any[] = [];

  filterId = localStorage.getItem("uid")

  public headers = new HttpHeaders({
    "X-LoginAccessKey": localStorage.getItem("accessKey")
  });

  constructor(
    private http: HttpClient,
    private router: Router,
    private snackBar: MatSnackBar) { }

  ngOnInit() {
    this.updateArea = {};
    this.updateAreaRelated = {};
    this.refreshAreas();
    this.getUser();
  }

  /**
   * 認証切れ（401・403）ならログイン画面へ戻す。それ以外のエラーは呼ぶ側で知らせる
   * @param error HTTP エラー
   * @returns ログイン画面へ戻したら true
   */
  isSignOut(error): boolean {
    if (error && (error.status == 401 || error.status == 403)) {
      alert("認証に失敗しました");
      this.router.navigate(['/']);
      return true;
    }
    return false;
  }

  refreshAreas() {
    this.http.get(API_BASE_URL + "/api/v1/area?type=" + this.tab, {
      headers: this.headers
    }).subscribe(res=> {
      let currentAreaId = this.updateArea.areaId;
      this.areaList = [];
      this.areaList = res as any[];

      // 現在選択されているエリアを選択しなおす
      this.areaList.forEach(area => {
        if (area.areaId == currentAreaId) {
          this.areaSelected(area);
          return;
        }
      })

    }, error => {
      if (this.isSignOut(error)) return;
      alert("エリアの取得に失敗しました。");
    })
  }

  /**
   * ユーザー取得
   */
  getUser() {
    this.http.get(API_BASE_URL + "/api/v1/users?userId=" + encodeURIComponent(this.filterId), {
      headers: this.headers
    }).subscribe(res=> {
      this.users = res as any[];
    }, error => {
      if (this.isSignOut(error)) return;
      alert("ユーザーの取得に失敗しました。");
    })
  }

  /**
   * エリアリストにあるエリアのみにする
   * @param e 
   * @param user 
   */
  onSelectOpened(opened: boolean, user) {
    if (opened) {
      if (this.tab === 1) {
        this.beforeArea = (user.filterArea || []).slice();
      } else if (this.tab === 2) {
        this.beforeArea = (user.filterAreaSalary || []).slice();
      }
      return
    }

    // 閉じた時
    let current = [];

    if (this.tab === 1) {
      current = user.filterArea || [];
    } else if (this.tab === 2) {
      current = user.filterAreaSalary || [];
    }

    // 比較して変更なければ保存しない
    if (JSON.stringify(this.beforeArea.sort()) === JSON.stringify(current.sort())) {
      return;
    }

    if (this.tab === 1) {
      user.filterArea = this.setArea(user.filterArea)
    } else if (this.tab === 2) {
      user.filterAreaSalary = this.setArea(user.filterAreaSalary)
    }

    this.http.post(API_BASE_URL + "/api/v1/users/" + user["id"], user, {
      headers: this.headers
    }).subscribe(res => {
      this.getUser();

      // ユーザー自身である場合
      if (user.userId == localStorage.getItem("uid")) {
        localStorage.setItem("filterArea", JSON.stringify(user["filterArea"]));
        localStorage.setItem("filterAreaSalary", JSON.stringify(user["filterAreaSalary"]));
      }

      this.snackBar.open('保存しました。', '閉じる', {
        duration: 1000,
        horizontalPosition: 'left',
        verticalPosition: 'top',
        panelClass: ['custom-snackbar']
      });
    }, error => {
      if (this.isSignOut(error)) return;
      this.getUser();
      alert("エリア初期値の保存に失敗しました。再度お願いします。");
    });
  }

  /**
   * 
   * @param userArea 選択肢にあるエリアのみ
   * @returns 
   */
  setArea(userArea) {
    if (userArea && Array.isArray(userArea)) {
      // areas に存在する areaId のみ残す
      const areaIdSet = new Set(this.areaList.map(a => a.areaId));
      return userArea.filter(id => areaIdSet.has(id));
    } else {
      return null
    }
  }

  /**
   * タブ切り替え
   */
  changeTab() {
    this.updateArea = {};
    this.areaRelatedList = [];
    this.refreshAreas()
  }

  /**
   * エリア名選択
   * @param area 対象エリアデータ
   */
  areaSelected(area) {
    // console.log(area);
    this.resetSelection(this.areaList);

    area.selected = true;
    this.areaRelatedList = area.areaRelateds;
    this.selectedArea = area;
    this.updateArea = JSON.parse(JSON.stringify(area));

    this.updateAreaRelated = {};
    this.selectedAreaRelated = null;
    this.resetSelection(this.areaRelatedList);
  }

  /**
   * エリア名追加
   */
  onNewAreaButton() {
    this.areaEditMode = true;
    this.updateArea = {'areaName': '', 'areaId': -1};
  }

  /**
   * エリア名更新
   * @returns 
   */
  onUpdateAreaButton() {
    if (!this.selectedArea) {
      window.alert('エリアを選択してください。');
      return;
    }
    this.areaEditMode = true;
  }

  /**
   * エリア保存
   */
  saveArea() {
    if (!this.updateArea.areaName) {
      alert('エリア名を入力してください。');
      return;
    }
    this.areaEditMode = false;
    this.http.post(API_BASE_URL + '/api/v1/area?type='
      + this.tab,
      this.updateArea, {headers: this.headers})
      .subscribe(res=> {
        this.refreshAreas();
      }, error => {
        if (this.isSignOut(error)) return;
        alert("エリア名の保存に失敗しました。");
      })
  }

  /**
   * エリア編集キャンセル
   */
  cancelArea() {
    this.areaEditMode = false;
  }

  /**
   * エリア削除
   * @returns 
   */
  deleteArea() {
    if (!this.selectedArea) {
      window.alert('エリアを選択してください。');
      return;
    }

    if (window.confirm('このエリアを削除しますか?')) {
      this.updateArea['deleteDate'] = new Date();
      this.http.post(API_BASE_URL + '/api/v1/area?type='
        + this.tab,
        this.updateArea, {headers: this.headers})
        .subscribe(res=> {
          this.refreshAreas();
        }, error => {
          if (this.isSignOut(error)) return;
          alert("エリア名の削除に失敗しました。");
        })
    }
  }

  /**
   * 関連名選択
   * @param areaRelated 
   */
  areaRelatedSelected(areaRelated) {
    // console.log(areaRelated);
    this.resetSelection(this.areaRelatedList);
    areaRelated.selected = true;
    this.selectedAreaRelated = areaRelated;
    this.updateAreaRelated = JSON.parse(JSON.stringify(areaRelated));
  }

  /**
   * 関連名追加
   */
  onNewAreaRelatedButton() {
    this.areaRelatedEditMode = true;
    this.updateAreaRelated = {'areaId': this.updateArea.areaId, 'areaRelatedName': '', 'areaRelatedId': -1};
  }

  /**
   * 関連名更新
   * @returns 
   */
  onUpdateAreaRelatedButton() {
    if (!this.selectedAreaRelated) {
      window.alert('エリアを選択してください。');
      return;
    }
    this.areaRelatedEditMode = true;
  }

  /**
   * 関連名保存
   */
  saveAreaRelated() {
    const id = this.updateAreaRelated.areaId
    const name = this.updateAreaRelated.areaRelatedName
    if (!name) {
      alert('関連名を入力してください。')
      return
    }

    // 重複チェック
    for (let i = 0; i < this.areaList.length; i++) {
      const row = this.areaList[i];
      for (let j = 0; j < row.areaRelateds.length; j++) {
        const a = row.areaRelateds[j]
        if (name == a.areaRelatedName) {
          alert(`『${row.areaName}』 にも同じ関連名があるため、登録できません。`)
          return
        }
      }
    }

    this.areaRelatedEditMode = false;
    this.http.post(API_BASE_URL + '/api/v1/arearelated?type='
      + this.tab,
      this.updateAreaRelated, {headers: this.headers})
      .subscribe(res=> {
        this.refreshAreas();
      }, error => {
        if (this.isSignOut(error)) return;
        alert("関連名の保存に失敗しました。");
      })
  }

  /**
   * 関連名削除
   * @returns 
   */
  deleteAreaRelated() {
    if (!this.selectedAreaRelated) {
      window.alert('エリアを選択してください。');
      return;
    }
    if (window.confirm('この関連名を削除しますか?')) {
      this.updateAreaRelated['deleteDate'] = new Date();
      this.http.post(API_BASE_URL + '/api/v1/arearelated?type='
        + this.tab,
        this.updateAreaRelated, {headers: this.headers})
        .subscribe(res=> {
          this.refreshAreas();
        }, error => {
          if (this.isSignOut(error)) return;
          alert("関連名の削除に失敗しました。");
        })
    }
  }

  /**
   * 関連名編集キャンセル
   */
  cancelAreaRelated() {
    this.areaRelatedEditMode = false;
  }

  private resetSelection(list) {
    list.forEach(item => {
      item.selected = false;
    })
  }
}
